import { useEffect, useRef } from 'react';

// 휴대폰 뒤로가기(브라우저 뒤로)로 열린 창을 위에서부터 하나씩 닫는다.
// 창이 열릴 때 주소는 그대로 두고 방문 기록만 한 칸 쌓고, 뒤로가기가 오면 맨 위 창을 닫는다.
// 예전에는 메시지 메뉴만 이렇게 했고, 사진 뷰어·서랍·패널에서 뒤로가기를 누르면 사이트를 떠났다.
const layers = [];
let ignorePops = 0;
// 버튼으로 닫아 지워야 할 기록 칸 수. 바로 history.back() 하면, 같은 순간에 다른 창이 열릴 때
// (계정 메뉴 → 계정 설정 창) 비동기 back 이 새 창의 칸을 지워 버려 그 뒤 뒤로가기가 사이트를 떠났다.
// 그래서 잠시 모았다가, 그 사이 새 창이 열리면 지울 칸을 그 창이 이어 쓰게 한다.
let pendingBacks = 0;
let backTimer = null;

if (typeof window !== 'undefined') {
    window.addEventListener('popstate', () => {
        if (ignorePops > 0) { ignorePops -= 1; return; }
        layers.pop()?.close();
    });
}

const flushBacks = () => {
    backTimer = null;
    const n = pendingBacks;
    pendingBacks = 0;
    // 그 사이 다른 화면으로 이동했다면(기록 맨 위가 우리 칸이 아니면) 되돌리지 않는다 — 이동이 취소되면 안 되므로
    if (n > 0 && window.history.state?.backLayer) {
        ignorePops += 1;
        window.history.go(-n);
    }
};

// 창 하나를 등록하고, 버튼 등으로 직접 닫을 때 부를 해제 함수를 돌려준다
export function pushBackLayer(close) {
    const layer = { close };
    layers.push(layer);
    if (pendingBacks > 0) pendingBacks -= 1; // 방금 닫힌 창의 칸을 이어 쓴다
    else window.history.pushState({ ...window.history.state, backLayer: layers.length }, '');
    return () => {
        const i = layers.indexOf(layer);
        if (i < 0) return; // 뒤로가기로 이미 닫힘
        layers.splice(i, 1);
        pendingBacks += 1;
        if (!backTimer) backTimer = setTimeout(flushBacks, 0);
    };
}

// open 인 동안 뒤로가기를 누르면 onClose 를 부른다
export function useBackClose(open, onClose) {
    const closeRef = useRef(onClose);
    closeRef.current = onClose;
    useEffect(() => {
        if (!open) return undefined;
        return pushBackLayer(() => closeRef.current?.());
    }, [open]);
}
